import { useLocation } from 'react-router-dom';
import { WEBINARS_PATH } from '@constants/paths';

/**
 * Custom hook to detect if the current route is a webinar page
 * @returns boolean indicating if current page is a webinar page
 */
export const useIsWebinarPage = (): boolean => {
  const { pathname } = useLocation();

  // Check if the pathname matches the pattern /webinars/{webinar-slug}
  return pathname.startsWith(WEBINARS_PATH) && pathname.split('/').length >= 3;
};

export default useIsWebinarPage;
